import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CountrySelectorComponent} from './country-selector.component';
import {ComboBoxModule} from '../combo-box/combo-box.module';
import {ComboBoxDropdownModule} from '../combo-box-dropdown/combo-box-dropdown.module';
import {TextSearchHighlightModule} from '../../pipes/text-search-highlight/text-search-highlight.module';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    CountrySelectorComponent
  ],
  imports: [
    CommonModule,
    ComboBoxModule,
    ComboBoxDropdownModule,
    TextSearchHighlightModule,
    FormsModule
  ],
  exports: [
    CountrySelectorComponent
  ]
})
export class CountrySelectorModule {
}
